<template>
  <modal :show.sync="modalDocsAdd">
    <h4 slot="header" class="title text-purple">
      {{ $t("app.modules.orders.documents.current_documents") }}
    </h4>

    <ValidationObserver ref="formAdd" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(submitNewType)">
        <div class="col-sm-12">
          <div class="row">
            <div class="row text-left">
              <div :class="sizes">
                <el-select
                  class="d-block"
                  size="large"
                  @change="changeSelect"
                  :placeholder="$t('app.modules.documentTypes.single')"
                  v-model="item.tipo_documento"
                >
                  <el-option
                    v-for="docType in docsTypes"
                    :value="docType.idTipoDocPedido"
                    :label="docType.nombre"
                    :key="docType.idTipoDocPedido"
                  >
                  </el-option>
                </el-select>
                <div
                  v-if="selectedEmptyOption"
                  class="text-danger invalid-feedback"
                  style="display: block;"
                >
                  {{ required_text }}
                </div>
              </div>
              <div :class="sizes">
                <el-upload
                  class="upload-demo large"
                  ref="upload"
                  action="#"
                  name="file_up"
                  :multiple="false"
                  :on-change="handleFile"
                  :on-remove="deleteFile"
                  :auto-upload="false"
                  accept=".pdf,image/x-png,image/gif,image/jpeg,docx"
                >
                  <n-button
                    slot="trigger"
                    size="small"
                    type="primary"
                    id="file_doc"
                    @click.native="onClick"
                    >{{ $t("app.upload.select_file") }}</n-button
                  >
                  <div class="el-upload__tip" slot="tip">
                    {{ $t("app.modules.orders.documents.admit_files") }}
                  </div>
                </el-upload>
                <div
                  v-if="fileEmpty"
                  class="text-danger invalid-feedback"
                  style="display: block;"
                >
                  {{ required_text }}
                </div>
              </div>
              <div :class="sizes">
                <n-button native-type="submit" type="primary"
                  ><i slot="label" class="now-ui-icons ui-1_simple-add"></i>
                  {{ $t("app.modules.orders.documents.add") }}</n-button
                >
              </div>
            </div>
          </div>
        </div>
      </form>
      <div
        slot="footer"
        style="margin-top: 10px; padding-top: 20px;border-top: outset;"
        class="text-right"
      >
        <n-button class="pull-left" @click.native="cancelAdd">{{
          $t("app.buttons.close")
        }}</n-button>
      </div>
    </ValidationObserver>
  </modal>
</template>
<script>
import { mapState } from "vuex";
export default {
  components: {},
  data() {
    return {
      modalDocsAdd: false,
      file_formats: ["pdf", "png", "gif", "jpeg", "docx"],
      file_doc: "",
      selectedEmptyOption: false,
      fileEmpty: false,
      docsTypes: [],
      selectedEmpty: false,
      required_text: this.$t("app.general.required"),
      sizes: "col-sm-4 col-md-4 col-lg-4",
      item: { tipo_documento: 0 }
    };
  },
  watch: {},
  computed: {},
  created() {},
  async mounted() {
    EventBus.$on("pedidos-docs-add", async item => {
      this.item.idPedido = item.idPedido;
      this.modalDocsAdd = true;
    });
    this.item.tipo_documento = 0;
    this.$swal.fire({
      title: this.$t("app.promps.wait"),
      html:
        '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
      showConfirmButton: false
    });
    await this.initPedidosDocs();
    this.$swal.close();
  },
  methods: {
    changeSelect(val) {
      console.log(val);
    },
    getFileExtension1(filename) {
      return /[.]/.exec(filename) ? /[^.]+$/.exec(filename)[0] : undefined;
    },
    onClick() {
      this.$refs.upload.clearFiles();
      this.file_doc = "";
    },
    async initPedidosDocs() {
      var payload = {
        id: 0,
        claveIdioma: this.$store.state.lang,
        usuario: this.$store.state.user.idUsuario
      };
      await this.$http
        .post(route("TipoDocumentoPedido/getTipoDocumentoPedido"), payload)
        .then(
          async response => {
            if (response.body.code === 200) {
              this.docsTypes = response.body.tipoDocumentoPedido;
              this.docsTypes.push({
                idTipoDocPedido: 0,
                nombre: this.$t("app.modules.documentTypes.single")
              });
            } else {
              this.notifyMessage("danger", this.$t("app.promps.error"));
            }
          },
          error => {
            console.log(error);
            this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        )
        .finally(() => {
          // Swal.close();
        });
    },

    async submitNewType() {
      console.log(this.item);
      if (this.item.tipo_documento >= 1) {
        this.selectedEmptyOption = false;
        console.log("Comprobar objeto");
        console.log(this.file_doc);
        if (this.file_doc == "" || this.file_doc.length < 0) {
          this.fileEmpty = true;
        } else {
          this.fileEmpty = false;
          console.log("Guardar item");
          console.log(this.item);
          this.saveItem();
        }
      } else {
        this.selectedEmptyOption = true;
      }
    },
    async saveItem() {
      //Guardar item
      let formData = new FormData();
      formData.append("DetallePedidos_idDetallePedido", this.item.idPedido);
      formData.append(
        "TipoDocumento_idTipoDocumento",
        this.item.tipo_documento
      );
      formData.append("IdUsuario", this.$store.state.user.idUsuario);
      formData.append("file", this.file_doc);
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });
      await this.$http
        .post(route("PedidoDocumento/postPedidoDocumento"), formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(
          async ResponsePedidoDocumento => {
            this.notifyMessage("success", this.$t("app.promps.save_success"));
            /*this.$refs.upload.clearFiles();
            this.file_doc = "";
            this.item.tipo_documento = 0;*/
            this.cancelAdd();
          },
          error => {
            this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        )
        .finally(() => {});
      this.$swal.close();
    },
    cancelAdd() {
      this.$refs.upload.clearFiles();
      this.$refs.formAdd.reset();
      this.item.nombreCategoria = "";
      this.modalDocsAdd = false;
      this.item.tipo_documento = 0;
    },
    handleFile(file) {
      if (file) {
        var extension = this.getFileExtension1(file.name);
        if (extension) {
          if (this.file_formats.includes(extension)) {
            this.file_doc = file.raw;
          } else {
            this.file_doc = "";
            this.$refs.upload.clearFiles();
            this.notifyMessage(
              "warning",
              this.$t("app.modules.orders.documents.message_incorrect")
            );
          }
        } else {
          this.file_doc = "";
          this.$refs.upload.clearFiles();
          this.notifyMessage(
            "warning",
            this.$t("app.modules.orders.documents.message_incorrect")
          );
        }
      }
    },
    async deleteFile(file) {
      this.file_doc = "";
    }
  }
};
</script>
<style>
.extended-forms .el-select {
  width: 100%;
  margin-bottom: 30px;
}
.card .alert {
  position: relative !important;
  width: 100%;
}

.modal-content .modal-header {
  padding-bottom: 24px;
  box-shadow: 0px 2px 5px 0px #00000021;
}

.modal-content .modal-body + .modal-footer {
  padding-top: 20px !important;
  background-color: #efefefb3;
}
</style>
